// extracted by mini-css-extract-plugin
export default {"icon":"ExhibitList_icon__lqd0f"};